const _AUTH = {
    
    SOCIAL_AUTH_REQUEST: 'SOCIAL_AUTH_REQUEST',
    SOCIAL_AUTH_SUCCESS: 'SOCIAL_AUTH_SUCCESS',
    SOCIAL_AUTH_FAILURE: 'SOCIAL_AUTH_FAILURE',

    UPDATE_REQUEST: 'UPDATE_REQUEST',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_FAILURE',


    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_SUCCESS_VERIFY_EMAIL: 'LOGIN_SUCCESS_VERIFY_EMAIL',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

    PASSWORD_RESET_REQUEST: 'PASSWORD_RESET_REQUEST',
    PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
    PASSWORD_RESET_FAILURE: 'PASSWORD_RESET_FAILURE',

    PASSWORD_RECOVERY_REQUEST: 'PASSWORD_RECOVERY_REQUEST',
    PASSWORD_RECOVERY_SUCCESS: 'PASSWORD_RECOVERY_SUCCESS',
    PASSWORD_RECOVERY_FAILURE: 'PASSWORD_RECOVERY_FAILURE'

}

export default _AUTH;